<template>
  <v-app id="inspire">
    <mo-header></mo-header>
    <br/>
    <v-content>
      <v-container fluid grid-list-xl>
        <div>
          <router-view></router-view>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

import Vue from 'vue';
import router from '@/router';
import {mapGetters} from 'vuex';
import QuoteValuePerRep from '../analytics/widgets/quote-value-per-rep';
import OnlineSalesReport from '../analytics/widgets/online-sales-report';
import Glance from '../analytics/widgets/glance';
import {GChart} from 'vue-google-charts'
import DashHeader from "./elements/DashHeader";
// import DatePicker from 'vue2-datepicker'
import './assets/css/section.css';

export default {
  data: () => ({
    dateRange: {
      from: {
        activated: false,
        value: ''
      },
      to: {
        activated: false,
        value: ''
      }
    }
  }),
  methods: {

  },
  computed: {
    ...mapGetters([
      'objAuthorize',
      'statusList',
      'isLoaded',
      'departmentList',
      'branchList',
      'widgetConfig'
    ])
  },
  props: {
    source: String
  },
  components: {
    DashHeader,
    GChart,
    QuoteValuePerRep,
    OnlineSalesReport,
    Glance
  },
  beforeMount() {
    this.$store.commit('fncIsLoaded', false);
  },
  mounted() {},
  watch: {

  }
}
</script>

<style scoped>
@import '../shared/assets/css/shared.css';
</style>
